import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import Home from '../pages/Home';
import Detail from '../pages/Detail';

const App = () => (
  <div id="app">
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/d/:app/" component={Detail} />
      </Switch>
    </Router>
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx